import { render, staticRenderFns } from "./ResetUAMPassword.vue?vue&type=template&id=616f64c6&scoped=true"
import script from "./ResetUAMPassword.vue?vue&type=script&lang=js"
export * from "./ResetUAMPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetUAMPassword.vue?vue&type=style&index=0&id=616f64c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616f64c6",
  null
  
)

export default component.exports